<template>
  <div class="filter-wrapper">
    <div class="heading">
      <h1 class="title">{{ filterVisible ? "Filter" : "Filter By" }}</h1>
    </div>
    <div class="filter-content">
      <div v-for="(item, index) in filters" :key="index">
        <CheckboxFilter
          v-if="
            configuration[item].type === 'checkbox' &&
            !configuration[item].hasSearch
          "
          :classname="configuration[item].hasScroll ? 'scroll' : ''"
          :filtername="item"
          :configuration="configuration"
          :filter="appliedFilters[item]"
          v-on="$listeners" />
        <CheckboxSearchFilter
          v-if="
            configuration[item].type === 'checkbox' &&
            configuration[item].hasSearch
          "
          :classname="configuration[item].hasScroll ? 'content scroll' : ''"
          :filtername="item"
          :configuration="configuration"
          :filter="appliedFilters[item]"
          v-on="$listeners" />
        <DropdownFilter
          v-if="configuration[item].type === 'dropdown'"
          :filtername="item"
          :configuration="configuration"
          :value="appliedFilters[item]"
          :is-open="item.expanded"
          v-on="$listeners" />
        <DateFilter
          v-if="configuration[item].type === 'date'"
          :filtername="item"
          :configuration="configuration"
          :value="appliedFilters[item]"
          v-on="$listeners" />
        <Radio
          v-if="configuration[item].type === 'radio'"
          custom-class="category"
          :name="item"
          :configuration="configuration"
          :enabled="appliedFilters[item]"
          v-on="$listeners" />
        <NumericFilter
          v-if="configuration[item].type === 'numeric'"
          :filtername="item"
          :configuration="configuration"
          :value="appliedFilters[item]"
          v-on="$listeners" />
        <TextboxFilter
          v-if="configuration[item].type === 'text'"
          :filtername="item"
          :configuration="configuration"
          :value="appliedFilters[item]"
          v-on="$listeners" />
      </div>
      <div v-if="filterVisible" class="button-area">
        <button class="cancel-button default" @click="onClearFilter">
          Cancel
        </button>
        <button class="apply-filter-button" @click="toggleFilter">
          Apply Filter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Filter Components
import CheckboxFilter from "@/components/Filter/CheckboxFilter.vue";
import CheckboxSearchFilter from "@/components/Filter/CheckboxSearchFilter.vue";
import DropdownFilter from "@/components/Filter/DropdownFilter.vue";
import DateFilter from "@/components/Filter/DateFilter.vue";
import NumericFilter from "@/components/Filter/NumericFilter";
import TextboxFilter from "@/components/Filter/TextboxFilter.vue";

import { Radio } from "@/components/common";

export default {
  name: "FilterWrapper",
  components: {
    CheckboxFilter,
    CheckboxSearchFilter,
    DropdownFilter,
    DateFilter,
    Radio,
    NumericFilter,
    TextboxFilter,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    },
    appliedFilters: {
      type: Object,
      required: true,
    },
    filterVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      filters: [],
    };
  },
  created() {
    let filterKeys = Object.keys(this.configuration);
    this.filters = filterKeys;
  },
  methods: {
    toggleFilter() {
      this.$emit("toggleFilter");
    },
    onClearFilter() {
      this.$emit("onClearFilter");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.filter-wrapper {
  width: 245px;
  padding-right: 14px;
  border-right: 1px solid var(--layout-border);
  padding-bottom: 24px;
  position: fixed;
  overflow-y: auto;
  top: 135px;
  bottom: 162px;

  @include media("<=desktop") {
    position: relative;
    top: 0;
  }
  & > .heading {
    display: flex;
    @include media("<=desktop") {
      padding: 8px;
      justify-content: space-between;
      & > .clear-filter {
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 12px;
        font-size: 14px;
        cursor: pointer;
        font-family: "Maersk Headline";
        color: var(--active-tab);
        text-decoration: underline;
        line-height: 16px;
      }
    }
    & .title {
      color: var(--primary-text);
      font-size: 18px;
      font-family: "Maersk Headline Light";
      font-weight: 600;
      margin: 0;
      margin-bottom: 24px;
    }
  }
  & .category {
    border-radius: 4px;
    padding: 12px;
    display: flex;
    background-color: var(--layout-bg);
    flex-direction: column;
    margin-bottom: 12px;
    &.multi-radio {
      @include media("<=desktop") {
        display: none;
      }
    }

    & .heading .down-arrow {
      transform: rotate(360deg);
    }
    & .heading .up-arrow {
      transform: rotate(180deg);
    }
    & .heading {
      cursor: pointer;
      justify-content: space-between;
      display: flex;
      align-items: center;
      flex: 1;
      & .down-arrow,
      .up-arrow {
        color: var(--icon-bg);
        fill: var(--icon-bg);
      }
      & .title {
        font-family: "Maersk Text";
        font-weight: 600;
        margin: 0;
        font-size: 14px;
        color: var(--primary-text);
      }
    }

    & .textinput input {
      background-color: var(--search-bar-bg);
      border-color: var(--tab-border);
      padding: 6px;
      margin: 10px 0;
      &:focus {
        outline-style: solid;
      }
    }

    & .date-content {
      max-height: unset !important;
    }

    & .content {
      display: flex;
      flex-direction: column;
      padding-top: 5px;
      max-height: 200px;

      &.scroll {
        overflow-y: auto;
      }

      &.date-picker {
        overflow: unset;
        max-height: unset;
        padding: 10px 0;
        & h6 {
          margin: 0;
          padding: 0;
          text-align: center;
          color: var(--primary-text);
        }

        & input {
          padding: 6px;
          margin: 10px 0;
          text-align: center;
          font-family: "Maersk Text";
          font-size: 12px;
          width: 94%;
          background: var(--search-bar-bg);
          color: var(--primary-text);
          resize: none;
          border-radius: 4px;
          border: 1px solid var(--tab-border);
          &[disabled] {
            cursor: not-allowed;
          }
        }
        & .date-button {
          background-color: var(--search-bar-bg);
          font-family: "Maersk Text";
          font-size: 12px;
          padding: 6px;
          border-radius: 4px;
          margin: 4px 0;
          color: var(--primary-text);
          text-align: center;
          cursor: pointer;
          &:hover {
            background-color: var(--active-tab);
            color: var(--white);
          }
        }
      }
      & .no-result {
        font-size: 12px;
        font-family: "Maersk Text";
        color: var(--primary-text);
      }
      &.multi-radio {
        flex-direction: row;
        align-items: center;
        & .title {
          font-family: "Maersk Text";
          font-size: 14px;
          color: var(--primary-text);
          font-weight: normal;
        }
        & .toggle {
          margin-right: 16px;
          margin-left: 16px;
        }
      }
      & .checkbox-area {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 8px 0;
        & .checkbox {
          display: block;
          position: relative;
          cursor: pointer;
          font-size: 22px;
          line-height: 16px;
          height: 16px;
          width: 16px;
          clear: both;
          & .checkbox-custom {
            position: absolute;
            top: 0;
            left: 0;
            height: 16px;
            width: 16px;
            background-color: transparent;
            border-radius: 4px;
            transition: all 0.3s ease-out;
            -webkit-transition: all 0.3s ease-out;
            -moz-transition: all 0.3s ease-out;
            -ms-transition: all 0.3s ease-out;
            -o-transition: all 0.3s ease-out;
            border: 1px solid var(--primary-text);
            &:after {
              position: absolute;
              content: "";
              left: 8px;
              top: 8px;
              height: 0px;
              width: 0px;
              border: var(--primary-text);
              border-width: 0 3px 3px 0;
              -webkit-transform: rotate(0deg) scale(0);
              -ms-transform: rotate(0deg) scale(0);
              transform: rotate(0deg) scale(0);
              opacity: 1;
            }
          }
          & input[type="checkbox"] {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }
          & input:checked ~ .checkbox-custom {
            -webkit-transform: rotate(0deg);
            background-color: var(--active-nav);
            border-radius: 5px;
            -webkit-transform: rotate(0deg) scale(1);
            -ms-transform: rotate(0deg) scale(1);
            transform: rotate(0deg) scale(1);
            opacity: 1;
            border: 1px solid var(--invert-color);
            &:after {
              -webkit-transform: rotate(45deg) scale(1);
              -ms-transform: rotate(45deg) scale(1);
              transform: rotate(45deg) scale(1);
              opacity: 1;
              left: 5px;
              top: 2px;
              width: 4px;
              height: 8px;
              border: solid var(--alt-color);
              border-width: 0 2px 2px 0;
              background-color: transparent;
              border-radius: 0;
            }
          }
        }
        & label {
          font-family: "Maersk Text";
          font-size: 14px;
          padding-left: 6px;
          color: var(--primary-text);
        }
      }
      & .filter-dropdown-group {
        font-size: 14px;
        &__control {
          border: 1px solid var(--tab-border);
          background-color: var(--search-bar-bg);
        }
        &__placeholder {
          font-size: 14px;
        }
        &__dropdown-indicator,
        &__indicator-separator {
          display: none;
        }
        &__input,
        &__single-value {
          color: var(--primary-text);
        }
      }
    }
    & .react-datepicker-popper {
      left: auto !important;
    }
  }

  & .button-area {
    display: none;

    @include media("<=desktop") {
      display: flex;
      flex-direction: row;
      position: relative;
      bottom: 24px;
      margin-top: 60px;
      margin-bottom: 24px;

      & button {
        display: flex;
        flex: 1 1;
        padding: 8px;
        background: var(--primary-button-color);
        color: var(--white);
        border-radius: 4px;
        justify-content: center;
        font-size: 16px;
        font-family: "Maersk Headline";
        cursor: pointer;
        border: none;
      }

      & .default {
        margin-right: 24px;
        background: var(--default-button-color);
        color: var(--primary-text);
      }
    }
  }
}
</style>
